import { Button } from "@blueprintjs/core";
import * as React from "react";
import styled from "styled-components";
import { useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IDrupalEmailErrorInfoProps {
  icon: string;
  text: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-self: center;
  align-items: center;
  height: 100%;
`;

export const DrupalEmailErrorInfo: React.FunctionComponent<IDrupalEmailErrorInfoProps> = ({ icon, text }) => {
  const mailTo = React.useCallback(() => {
    window.location.href = "mailto:info@srsh.be";
  }, []);

  const { t } = useTl();
  return (
    <Container>
      <i className={icon} />
      <p style={{ width: "80%", fontSize: "13pt", marginTop: "2rem", marginBottom: "2rem" }}>{text}</p>
      <Button intent="primary" onClick={mailTo} text={t(ETLCodes.ContactUs)} icon="envelope" />
    </Container>
  );
};
